window.onload = function () {
    let loop = true;
	const slider = new KeenSlider('.keen-slider', {
		loop: loop,
		renderMode: "performance",
		slides: {
			perView: 1
		},
		breakpoints: {
			"(min-width: 720px)": {
				slides: {
					perView: 1
				}
			},
			"(min-width: 1024px)": {
				slides: {
					perView: 1
				}
			},
			"(min-width: 1440px)": {
				slides: {
					perView: 1
				}
			},
		}
	}, [navigation]);

	let slideContentContainer = document.querySelectorAll('.slide-content-container');
	slideContentContainer.forEach(function(el) {
		let slideContentArea = el.querySelector('.slide-content-area');
		let h4 = slideContentArea.querySelector('h4');
		let h2 = slideContentArea.querySelector('h2');
		let p = slideContentArea.querySelector('p');
		if (h4.innerHTML === '' && h2.innerHTML === '' && p.innerHTML === '') {
			el.classList.add('hidden');
		}
	});

};

function navigation(slider) {
	let navigation_wrapper, arrowLeft, arrowRight

	function markup(remove) {
		wrapperMarkup(remove)
		arrowMarkup(remove)
	}

	function removeElement(elment) {
		elment.parentNode.removeChild(elment)
	}

	function createDiv(className) {
		var div = document.createElement("div")
		var classNames = className.split(" ")
		classNames.forEach((name) => div.classList.add(name))
		return div
	}

	function arrowMarkup(remove) {
		if (remove) {
			removeElement(arrowLeft)
			removeElement(arrowRight)
			return
		}
		arrowLeft = renderArrowIcon('left')
		arrowLeft.addEventListener("click", () => slider.prev())
		arrowRight = renderArrowIcon('right')
		arrowRight.addEventListener("click", () => slider.next())

		navigation_wrapper.appendChild(arrowLeft)
		navigation_wrapper.appendChild(arrowRight)
	}

	function wrapperMarkup(remove) {
		if (remove) {
			var parent = navigation_wrapper.parentNode
			while (navigation_wrapper.firstChild)
				parent.insertBefore(navigation_wrapper.firstChild, navigation_wrapper)
			removeElement(navigation_wrapper)
			return
		}
		if( slider.slides.length > 1 ) {
			navigation_wrapper = createDiv("keen-slider-navigation-wrapper")
			slider.container.parentNode.appendChild(navigation_wrapper)
		}
	}

	function renderArrowIcon(direction) {
		const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		const iconPath = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'path'
		);

		iconSvg.setAttribute('fill', '#fff');
		iconSvg.setAttribute('viewBox', '0 0 24.64 46.792');
		iconSvg.classList.add('keen-slider-navigation-arrow');
		iconSvg.classList.add(`arrow--${direction}`);

		if (direction === 'left') {
			iconPath.setAttribute(
				'd',
				'M21.665.522.5,22.163a1.766,1.766,0,0,0,0,2.464L21.665,46.27a1.728,1.728,0,0,0,2.459.016A1.769,1.769,0,0,0,24.14,43.8L4.182,23.395,24.14,2.987A1.767,1.767,0,0,0,24.124.506a1.727,1.727,0,0,0-2.459.016Z'
			);
		} else {
			iconPath.setAttribute(
				'd',
				'M2.975.522,24.139,22.163a1.766,1.766,0,0,1,0,2.464L2.975,46.27a1.728,1.728,0,0,1-2.459.016A1.769,1.769,0,0,1,.5,43.8l19.958-20.41L.5,2.987A1.767,1.767,0,0,1,.517.506,1.727,1.727,0,0,1,2.975.522Z'
			);
		}
		iconSvg.appendChild(iconPath);

		return iconSvg
	}

	function updateClasses() {
        let loop = slider.options.loop;
		var slide = slider.track.details.rel
		slide === 0 && !loop ?
			arrowLeft.classList.add("arrow--disabled") :
			arrowLeft.classList.remove("arrow--disabled")
		slide === slider.track.details.slides.length - 1 && !loop ?
			arrowRight.classList.add("arrow--disabled") :
			arrowRight.classList.remove("arrow--disabled")
	}

	slider.on("created", () => {
		markup()
		updateClasses()
	})
	slider.on("optionsChanged", () => {
		console.log(2)
		markup(true)
		markup()
		updateClasses()
	})
	slider.on("slideChanged", () => {
		updateClasses()
	})
	slider.on("destroyed", () => {
		markup(true)
	})
}
